export default {"src":"/_next/static/media/logo-2.4be82553.svg","height":191,"width":427,"blurWidth":0,"blurHeight":0};